export default __webpack_public_path__ + "static/media/login_white_24dp.2413e54b.svg";